
const GetDefaultValuesFromPage = (pageStructure, existingValues) => {

    let defaultValues = {};
    for (const page of pageStructure) {
        for (const column of page.Columns) {
            for (const formGroup of column.FormGroups) {
                for (const field of formGroup.Fields) {
                    var matchIndex = -1;
                    if (existingValues !== null) {
                        matchIndex = existingValues.findIndex(item => item.toLowerCase() === field.Id.toLowerCase());
                    }
                    if (matchIndex !== -1) {
                        continue;
                    }
                    const isDependantDefault = field.DefaultValue.includes("<:") && field.DefaultValue.includes(":>")
                    if (field.DefaultValue !== undefined && field.DefaultValue !== "" && ! isDependantDefault) {
                        defaultValues[field.Id] = field.DefaultValue;
                    } else if (field.DefaultToNow) {
                        switch (field.Type) {
                            case 'date':
                                let currentDate = new Date();
                                defaultValues[field.Id] = currentDate.getFullYear() + '-' + (currentDate.getMonth()+1) + '-' + currentDate.getDate();
                                break;
                            case 'singleline':
                            default:
                                let currentDate2 = new Date();
                                defaultValues[field.Id] = String(currentDate2.getHours()).padStart(2, "0") + ":" + String(currentDate2.getMinutes()).padStart(2, "0");
                        }
                    }
                }
            }
        }

    }
    
    return defaultValues;

}

const SetDynamicDefaultValues = (pageStructure, id, value) => {

    let defaultValues = [];
    for (const page of pageStructure) {
        for (const column of page.Columns) {
            for (const formGroup of column.FormGroups) {
                for (const field of formGroup.Fields) {
                    if (field.DefaultValue !== undefined && field.value === undefined) {
                        if (field.DefaultValue.includes("<:") && field.DefaultValue.includes(":>")) {
                            const fieldToMatch = field.DefaultValue.replace("<:","").replace(":>","").trim().toLowerCase();
                            if (id.toLowerCase() === fieldToMatch) {
                                field.value = value;
                                defaultValues.push({id: field.Id, value: value})
                            }
                        }
                    }
                }
            }
        }

    }
    
    return defaultValues;

}

export default GetDefaultValuesFromPage;
export {SetDynamicDefaultValues};